import type { ReactNode } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  subtitle?: string | null;
  defaultExpanded?: boolean;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  children: ReactNode;
  testId?: string;
};

export function EmploymentSectionAccordion({
  title,
  subtitle,
  defaultExpanded = false,
  expanded,
  onExpandedChange,
  children,
  testId,
}: Props) {
  return (
    // Wrapper keeps Stack/sibling spacing when disableGutters zeros Accordion margin on expand.
    <Box sx={{ width: '100%' }}>
      <Accordion
        disableGutters
        elevation={0}
        expanded={expanded}
        defaultExpanded={expanded === undefined ? defaultExpanded : undefined}
        onChange={onExpandedChange ? (_event, next) => onExpandedChange(next) : undefined}
        data-testid={testId}
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          '&:before': { display: 'none' },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
          <Stack spacing={0.25} sx={{ minWidth: 0, pr: 1 }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
              {title}
            </Typography>
            {subtitle ? (
              <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1.4 }}>
                {subtitle}
              </Typography>
            ) : null}
          </Stack>
        </AccordionSummary>
        <AccordionDetails sx={{ pt: 0 }}>{children}</AccordionDetails>
      </Accordion>
    </Box>
  );
}
